<script>
  import {
    pageToLoad,
    pageStack,
    user,
    enableBackButton,
    transitionString,
  } from "./scripts/stores.js";
  import { pages } from "./scripts/pages.js";
  import { fade } from "svelte/transition";

  const showBackButtonCheck = (pageStackLocal) => {
    if (!$enableBackButton) {
      return false;
    }
    if (pageStackLocal.length <= 1) {
      return false;
    }
    for (let aPage of pageStackLocal) {
      if (pages[aPage].skip == false) {
        return true;
      }
    }
    return false;
  };

  let showBackButton;
  $: showBackButton = showBackButtonCheck($pageStack);

  const goBack = () => {
    console.log("in the back function");
    $pageStack.pop(); // remove the current page
    let previousPage = $pageStack.pop(); // grab the previous page
    console.log(previousPage);
    while (pages[previousPage].skip) {
      console.log("about to skip this last page here");
      console.log($pageStack);
      previousPage = $pageStack.pop(); // if that one was skippable, go back one more
    }
    transitionString.set("back");
    pageToLoad.set(previousPage); // go to the previous page
  };
</script>

<main>
  <div class="container">
    <div class="button-icon" id="back" on:click={goBack}>
      {#if showBackButton}
        <img
          src="./images/arrow-left.svg"
          alt="Back"
          width="30px"
          class="icon"
          transition:fade
        />
      {/if}
    </div>
    <div
      class="button-icon"
      id="dashboard"
      on:click={() => pageToLoad.set("dashboard")}
    >
      {#if $user.loggedIn}
        <img
          src="./images/user-icon.svg"
          alt="Dashboard"
          width="30px"
          class="icon"
          transition:fade
        />
      {/if}
    </div>
    <div class="logo-centered">
      <a href="https://www.synthase.cc">
        <img
          src="./images/synthase-logo.svg"
          alt="Synthase"
          title="Synthase"
          height="40px"
        />
      </a>
    </div>
  </div>
</main>

<style>
  main {
    background-color: #212121;
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
  }

  #back {
    float: left;
    margin: auto 10px;
  }
  #dashboard {
    float: right;
    margin: auto 10px;
  }
  .button-icon {
    cursor: pointer;
    z-index: 1;
  }
  .container {
    display: flex;
    height: 50px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 500px;
  }
  .logo-centered {
    position: absolute;
    text-align: center;
    left: 0;
    right: 0;
    z-index: 0;
  }
</style>
